import { useEffect, useState } from "react";

const MOBILE_REGEX = /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/

export const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const handleResize = () => {
      if (window && window.navigator) {
        const { userAgent } = window.navigator;
        if (MOBILE_REGEX.test(userAgent)) {
          return setIsMobile(true);
        }
        else {
          return setIsMobile(false);
        }
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  })

  return {
    isMobile
  }
}
